module.exports = __webpack_public_path__ + "assets/img/shortsPlatform-automatic.485270ff.png";